import React, { Component } from 'react';
import { Redirect } from 'react-router';
import { Link } from 'react-router-dom';
import '../common/MdPage.css';
import * as constantClass from '../fileWithConstants';
import { ChevronLeftIcon } from '../common/mdPageIcons';
import * as periodosService from '../../services/periodos/periodosService';
import {
  buildPeriodoExamenValidationError,
  classifyPeriodosError,
  toCreatePeriodoExamenPayload,
  validatePeriodDates,
  validatePeriodoExamenFormAdd,
} from '../../services/periodos/periodosDto';
import { LookupAnioAcademicos } from '../AnioAcademico/LookupAnioAcademicos';
import { todayCalendarDate } from '../../services/dates/dateService';
import { CalendarDatePicker } from '../common/CalendarDatePicker';

export class AddPeriodoExamen extends Component {
  static displayName = AddPeriodoExamen.name;

  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      descripcion: '',
      showErrorMessage: false,
      success: false,
      errorMessage: '',
      showLookupAnios: false,
      anio: { codigo: '', descripcion: '' },
      startDate: todayCalendarDate(),
      endDate: todayCalendarDate(),
      llamado: '',
    };
  }

  async componentDidMount() {
    await constantClass.canAccess('WWPeriodoExamen');
  }

  handleConfirmButton = () => {
    const datesOk = validatePeriodDates(this.state.startDate, this.state.endDate);
    const isOkToSave = validatePeriodoExamenFormAdd({
      descripcion: this.state.descripcion,
      llamado: this.state.llamado,
      anioDescripcion: this.state.anio.descripcion,
      startDate: this.state.startDate,
      endDate: this.state.endDate,
    });
    const errorMessage = buildPeriodoExamenValidationError({ formValid: isOkToSave, datesOk });

    if (isOkToSave && datesOk) {
      this.saveStudent();
      return;
    }

    this.setState({ showErrorMessage: true, errorMessage });
  };

  handleShowAniosLookup = () => {
    this.setState({ showLookupAnios: true });
  };

  handleStartDate = (date) => {
    this.setState({ startDate: date, showErrorMessage: false, errorMessage: '' });
  };

  handleEndDate = (date) => {
    this.setState({ endDate: date, showErrorMessage: false, errorMessage: '' });
  };

  handleHideLookup = () => {
    this.setState({ showLookupAnios: false });
  };

  handleDescripcionChangeInput = (e) => {
    this.setState({ descripcion: e.target.value, showErrorMessage: false, errorMessage: '' });
  };

  handleLlamadoChangeInput = (e) => {
    this.setState({ llamado: e.target.value, showErrorMessage: false, errorMessage: '' });
  };

  handleSelectAnioItem = (e) => {
    const anioProperties = e.split('%');
    this.setState({
      showLookupAnios: false,
      showErrorMessage: false,
      errorMessage: '',
      anio: {
        codigo: anioProperties[0],
        descripcion: anioProperties[1],
      },
    });
  };

  render() {
    if (this.state.success) {
      return <Redirect to="/md-pex" />;
    }

    const { loading } = this.state;

    return (
      <div className="md-page md-add-pex">
        <Link className="md-page__back-link" to="/md-pex">
          <ChevronLeftIcon />
          Volver al listado
        </Link>

        <div className="md-page__header">
          <h1 className="md-page__title">Nuevo Período de Examen</h1>
        </div>
        <p className="md-page__subtitle">
          Complete período, llamado, año académico y fechas de inicio y fin.
        </p>

        <div className="md-page__feedback" aria-live="polite" role="status">
          {this.state.showErrorMessage ? (
            <div className="md-page__error" role="alert">{this.state.errorMessage}</div>
          ) : null}
          {loading ? (
            <div className="md-page__status">Los datos se están guardando, espere unos segundos...</div>
          ) : null}
        </div>

        <div className="md-page__form-card">
          <div className="md-page__field">
            <label className="md-page__field-label" htmlFor="pex-descripcion">
              Período de examen
            </label>
            <input
              id="pex-descripcion"
              className="md-page__field-input"
              type="text"
              placeholder="Ingrese período de examen"
              value={this.state.descripcion}
              onChange={this.handleDescripcionChangeInput}
              disabled={loading}
            />
          </div>

          <div className="md-page__field">
            <label className="md-page__field-label" htmlFor="pex-llamado">
              Llamado
            </label>
            <input
              id="pex-llamado"
              className="md-page__field-input"
              type="text"
              placeholder="Ingrese llamado"
              value={this.state.llamado}
              onChange={this.handleLlamadoChangeInput}
              disabled={loading}
            />
          </div>

          <div className="md-page__field">
            <span className="md-page__field-label">Año académico</span>
            <div className="md-page__picker-block">
              {!loading ? (
                <button type="button" className="md-page__picker-link" onClick={this.handleShowAniosLookup}>
                  Seleccionar año académico
                </button>
              ) : null}
              <div className="md-page__field-readonly">{this.state.anio.descripcion || '\u00a0'}</div>
            </div>
          </div>

          <section className="md-page__form-section">
            <p className="md-page__form-section-title">Fechas del período</p>
            <div className="md-page__form-date-row">
              <div className="md-page__field">
                <label className="md-page__field-label" htmlFor="pex-fecha-inicio">
                  Fecha de inicio
                </label>
                <CalendarDatePicker
                  inputId="pex-fecha-inicio"
                  className="md-page__field-input"
                  selected={this.state.startDate}
                  onChange={this.handleStartDate}
                  disabled={loading}
                />
              </div>
              <div className="md-page__field">
                <label className="md-page__field-label" htmlFor="pex-fecha-fin">
                  Fecha de fin
                </label>
                <CalendarDatePicker
                  inputId="pex-fecha-fin"
                  className="md-page__field-input"
                  selected={this.state.endDate}
                  onChange={this.handleEndDate}
                  disabled={loading}
                />
              </div>
            </div>
          </section>

          <div className="md-page__form-actions">
            <button
              type="button"
              className="md-page__form-btn md-page__form-btn--primary"
              onClick={this.handleConfirmButton}
              disabled={loading}
            >
              Guardar cambios
            </button>
          </div>
        </div>

        {this.state.showLookupAnios ? (
          <LookupAnioAcademicos selectItem={this.handleSelectAnioItem} hideLookup={this.handleHideLookup} />
        ) : null}
      </div>
    );
  }

  async saveStudent() {
    this.setState({ showErrorMessage: false, loading: true });
    try {
      await periodosService.savePeriodoExamen(
        toCreatePeriodoExamenPayload({
          descripcion: this.state.descripcion,
          llamado: this.state.llamado,
          fechaInicio: this.state.startDate,
          fechaFin: this.state.endDate,
          anioAcademicoCod: this.state.anio.codigo,
        })
      );
      this.setState({ loading: false, success: true, errorMessage: '' });
    } catch (error) {
      const outcome = classifyPeriodosError(error);
      if (outcome.type === 'timeout') {
        constantClass.RedirectToLogin();
        return;
      }
      this.setState({
        loading: false,
        success: false,
        showErrorMessage: true,
        errorMessage: outcome.message,
      });
    }
  }
}
